module.exports = __webpack_public_path__ + "static/media/galerija_2021 (14)-min.aab63534.jpg";